import React from 'react';
import { Icon } from './Icon.js';
export const IconChartStackedLine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 14.2292L17.2727 21L21.5 12.9519", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M2.55704 21L8.5 10.3306L12.0448 11.9689L15.5897 13.6073L21.4477 3.00002", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartStackedLine.js.map